import React, { Component } from 'react'

class Properties extends Component {
  renderArray(array) {
    const values = array.value.map((property) => {
      return this.renderProperty(property)
    }).join(', ')
    return `[${values}]`
  }

  renderNumber(property) {
    return `${property.value}`
  }

  renderString(property) {
    return `"${property.value}"`
  }

  renderProperty(property) {
    if (property.type === 'array') {
      return this.renderArray(property)
    }

    if (property.type === 'number') {
      return this.renderNumber(property)
    }

    if (property.type === 'string') {
      return this.renderString(property)
    }
  }

  renderProperties() {
    const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'})
    const properties = this.props.class.properties
    const propertiesKeys = Object.keys(properties).sort(collator.compare)

    return propertiesKeys.map((key) => {
      const property = properties[key]
      return (
        <tr key={key}>
          <td>{key}</td>
          <td>{this.renderProperty(property)}</td>
        </tr>
      )
    })
  }

  render() {
    const properties = this.renderProperties()

    return (
      <div>
        <h3>Properties</h3>
        <table>
          <tbody>
            {properties}
          </tbody>
        </table>
      </div>
    )
  }
}

export default Properties



// WEBPACK FOOTER //
// ./src/Properties.js